export default __webpack_public_path__ + "static/media/documents.bb44e1fe.svg";